import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import SearchBox from "../../Interfaces/SearchBoxProps";
import SortFilter from "./hooks/SortFilter";
import { CompleteOrderRow } from "./../DentistHub/interface/CompleteOrderRow";
import { apiAxios } from "../../utils/apiAxios";
import { RatingCell } from "./RatingCell";
const CompleteOrder: React.FC = () => {


  const [orders, setOrders] = useState<CompleteOrderRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrder, setSelectedOrder] = useState<CompleteOrderRow | null>(null);
  const [showModal, setShowModal] = useState(false);
const [orderView, setOrderView] = useState<"full" | "design">("full");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage] = useState(10);

  // 🔥 API CALL
  const fetchOrders = async (pageNumber = 1, search = "") => {
    try {
      setLoading(true);

      const res = await apiAxios.get("/Dentist/completed-orders", {
        params: {
          search,
          pageNumber,
          pageSize: perPage,
          clinicID: JSON.parse(sessionStorage.getItem("selectedClinic") || "{}").clinicID || null
        }
      });

      const json = res.data;
      if (json.isSuccess) {

        const apiData = json.dataOne.data;

        const mapped = apiData.map((item: any) => ({
          orderId: item.orderID ?? "-",
          clinicName: item.clinicName ?? "-",
          phone: item.phone ?? "-",
          orderTypeName: item.orderTypeName ?? "-",
          orderDate: item.orderDate
            ? new Date(item.orderDate).toLocaleString("en-GB")
            : "-",
          millingHub: item.millingHub ?? "-",
          designerName: item.designerName ?? "-",
          deliveryPartner: item.deliveryPartner ?? "-",
          deliveryDate: item.deliveryDate
            ? new Date(item.deliveryDate).toLocaleString("en-GB")
            : "-",
          amount: item.amount ?? "-",
          payment: item.paymentStatus ?? "-",
          paymentType: "Online",
          status: item.status ?? "-",
          caseId: item.caseID,          // ADD
          clinicID: item.clinicID,    // ADD
          overallRating : item.overallRating
        }));

        setOrders(mapped);
        setTotalRows(json.dataOne.totalRecords);

      } else {
        toast.error("No data found");
      }

    } catch (error) {
      console.error(error);
      toast.error("Failed to load completed orders");
    } finally {
      setLoading(false);
    }
  };

  // 🔥 PAGE CHANGE
  useEffect(() => {
    fetchOrders(page, searchText);
  }, [page]);

  // 🔥 SEARCH (Debounce)
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(1);
      fetchOrders(1, searchText);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchText]);
  const displayedOrders = orders.filter(order =>
  orderView === "design"
    ? order.orderTypeName === "Design Service"
    : order.orderTypeName !== "Design Service"
);

  // 🔥 TABLE COLUMNS
  const columns = [
    {
      name: "OrderID",
      selector: (row: CompleteOrderRow) => row.orderId,
      sortable: true
    },
    {
      name: "Order Type",
      selector: (row: CompleteOrderRow) => row.orderTypeName,
      sortable: true
    },

    {
      name: "Clinic / Phone",
      minWidth: "180px",
      cell: (row: CompleteOrderRow) => (
        <div>
          <div className="fw-semibold">{row.clinicName}</div>
          <div className="text-muted">{row.phone}</div>
        </div>
      )
    },

    {
      name: "Order Date",
      selector: (row: CompleteOrderRow) => row.orderDate,
      minWidth: "170px"
    },

 ...(orderView !== "design"
    ? [
        {
          name: "Milling Hub",
          selector: (row: CompleteOrderRow) => row.millingHub,
        },
      ]
    : []),

    {
      name: "Payment",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.amount}
        </span>
      )
    },

    {
      name: "Status",
      cell: (row: CompleteOrderRow) => (
        <span className="badge bg-success">
          {row.status}
        </span>
      )
    },
  
 
{
  name: "Rating",
  cell: (row: CompleteOrderRow) => (
    <RatingCell
      row={row}
      onRated={(rating) => {
        setOrders(prev =>
          prev.map(item =>
            item.caseId === row.caseId
              ? { ...item, overallRating: rating }
              : item
          )
        );
      }}
    />
  ),
},
 


    {
      name: "View",
      cell: (row: CompleteOrderRow) => (
        <button
          className="action-btn edit"
          onClick={() => {
            setSelectedOrder(row);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye"></i>
        </button>
      )
    }

  ];

  return (

    <div className="container-fluid mt-4">

      <h4 className="mb-4">Completed Orders</h4>

      <div className="premium-card p-4">

        <div className="row mb-3 ">
          <div className="col-md-6">
   <div className="mb-3 d-flex gap-4">
          <label>
            <input
              type="radio"
              checked={orderView === "full"}
              onChange={() => setOrderView("full")}
            />
            {" "}Full Service
          </label>

          <label>
            <input
              type="radio"
              checked={orderView === "design"}
              onChange={() => setOrderView("design")}
            />
            {" "}Design Service
          </label>
        </div>
          </div>

        <div className="col-md-6 d-flex justify-content-end">
              <SearchBox
            value={searchText}
            onChange={setSearchText}
          />

          <SortFilter />
          </div>
        

        </div>

        <DataTable
          columns={columns}
          data={displayedOrders}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={(page) => setPage(page)}
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />

      </div>
      {/* 🔥 MODAL */}
      {showModal && selectedOrder && (

        <div className="modal fade show d-block modal-bg">

          <div className="modal-dialog modal-lg">

            <div className="modal-content">
              <div className="modal-header premium-modal-header">
                {/* <h5>Order Details</h5> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>

                <button
                  className="custom-close-btn btn-close "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>

              </div>

              <div className="modal-body premium-modal-body pt-0">

                <ul className="list-unstyled order-details-list mb-0">

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Designer</span>
                    <span className="value text-start">{selectedOrder.designerName}</span>
                  </li>

                  {selectedOrder.orderTypeName !== "Design Service" && (
    <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
      <span className="label">Delivery Partner</span>
      <span className="value text-start">
        {selectedOrder.deliveryPartner}
      </span>
    </li>
  )}

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Delivery Date</span>
                    <span className="value text-start">{selectedOrder.deliveryDate}</span>
                  </li>

                  <li className="order-item d-flex justify-content-between align-items-center border-bottom py-2">
                    <span className="label">Order Type</span>
                    <span className="value text-start">{selectedOrder.orderTypeName}</span>
                  </li>

                  <li className="order-item d-flex justify-content-between align-items-center py-2">
                    <span className="label">Payment Type</span>
                    <span className="value">{selectedOrder.paymentType}</span>
                  </li>

                </ul>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

export default CompleteOrder;